var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "syf-component-library/ui/spacing";
import getTranslation from "../../../strings/getTranslations";
import { useConfig } from "../../../hooks/useConfig";
import { IMAGE_ASSETS } from "../../../const/assets";
import { StatusMessage } from "../../atoms/StatusMessage";
var IncomeCaptureError = function () {
    var profileConfig = useConfig();
    var assets = profileConfig.hosts.assets;
    var t = getTranslation().t;
    var errorImage = "".concat(assets).concat(IMAGE_ASSETS.CAT_ERROR);
    return (_jsxs(StatusMessage.Container, { children: [_jsx(StatusMessage.Image, { src: errorImage, alt: "" }), _jsx(Stack, { size: "xlarge" }), _jsx(StatusMessage.TextBlock, __assign({ size: 20, weight: "semiBold" }, { children: t("incomeCapture.error.default.title") })), _jsx(Stack, { size: "large" }), _jsx(StatusMessage.TextBlock, __assign({ size: 14 }, { children: t("incomeCapture.error.default.subtitle") }))] }));
};
export default IncomeCaptureError;
